// src/components/WhatsAppFloat.jsx
import { useState } from 'react';

const WhatsAppFloat = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  const phoneNumber = '918121222666';
  const message = 'Hello! I’d like to book an appointment.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div className="fixed bottom-[max(1.5rem,env(safe-area-inset-bottom))] right-[max(1.5rem,env(safe-area-inset-right))] z-50 group">
      {/* Main floating button container */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16
                   bg-[#25D366] text-white rounded-full shadow-xl
                   hover:shadow-2xl hover:bg-[#20b858]
                   transition-all duration-300
                   hover:scale-110 active:scale-95
                   focus:outline-none focus:ring-4 focus:ring-green-300/50"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
      >
        {/* Pulse background effect */}
        <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping pointer-events-none" />

        {/* Icon container */}
        <div className="relative z-10 flex items-center justify-center w-full h-full">
          <i className="fab fa-whatsapp text-3xl md:text-4xl" />
        </div>

        {/* Optional subtle inner ring */}
        <span className="absolute inset-1.5 rounded-full border-2 border-white/25 pointer-events-none" />
      </a>

      {/* Tooltip */}
      <div
        className={`absolute bottom-full right-0 mb-3 
                    flex items-center justify-center
                    px-4 py-2 bg-gray-900/95 text-white text-sm font-medium
                    rounded-lg shadow-lg whitespace-nowrap
                    transition-all duration-200 pointer-events-none
                    ${showTooltip
                      ? 'opacity-100 translate-y-0 visible'
                      : 'opacity-0 translate-y-2 invisible'}`}
      >
        Chat on WhatsApp

        {/* Tooltip arrow */}
        <div className="absolute -bottom-1.5 right-4 w-3 h-3 bg-gray-900 rotate-45" />
      </div>
    </div>
  );
};

export default WhatsAppFloat;